import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, delay, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseTypeDoc } from '../interfaces/type-document.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({providedIn: 'root'})
export class TypeDocValidatorService implements AsyncValidator {
  typeDocTakenError: string | null = null;
  private baseUrl: string = environment.baseUrlAuth;

  private http =            inject(HttpClient);
  private _coreService =    inject(CoreService);


  validate(control: AbstractControl<any, any>): Observable<ValidationErrors | null> {
    const typeDocValue: string = control.value;
    const apiUrl = `${this.baseUrl}/api/tipos-documentos/${typeDocValue}`;

    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type':   'application/json',
      'Authorization':  `Bearer ${authToken}`
    });

    return this.http.get<ResponseTypeDoc>(apiUrl, {headers})
    .pipe(
      map(resp => {
        if (resp.idSiesa === typeDocValue) {
          // console.log(resp.idSiesa, '===', typeDocValue)
          this.typeDocTakenError = `El tipo doc: "${typeDocValue}" ya esta creado`;
          this._coreService.openInfoSnackbar(`El tipo doc: "${typeDocValue}" ya esta creado`, 'Ok');
          return {
            typeDocTaken: true
          };
        } else {
          this.typeDocTakenError = null
          return null;
        }
      })).pipe(
        delay(100)
    )
  }


}
